import { LadiesMain } from "../../global/ladies-main"
import { InfoPanel } from "../../info-panel/InfoPanel"
import { openGenericModal } from "../../util/generic-modal"

export default class StarsPostsComments {
    constructor(StarsPost) {
        if (userData.userId === 0) {
            return
        }
        this.apiBaseUrl = SiteInfo.yiiLadiesApiUrl
        /**
         * @type {?string}
         */
        this.postId = null
        /**
         * @type {boolean}
         */
        this.subsriptionExpired = true

        /**
         * @type {StarsPost}
         */
        this.StarsPost = StarsPost
        /**
         * @type {string}
         */
        this.starId = window.location.pathname.substring(window.location.pathname.indexOf("-") + 1)
        this.creatorId = window.location.pathname.match(/\/stars\/(\d+)\//)?.[1] || ""

        const postId = LadiesMain._getHashtagObject().postId
        const commentId = LadiesMain._getHashtagObject().commentId

        if (postId && commentId) {
            if (userData.userId === 0 || !userData.isLoggedIn) {
                const loginModal = document.getElementById("age-verification-modal")
                $(loginModal).modal("show")

                return
            }
            this.openSubscriptionModal()
        }

        this.subsriptionExpired = false

        this.openCommentButtons = document.querySelectorAll('.post-comments-button[data-target=""]')
        // only inside post stream, NOT single view
        this.commentsModal = document.getElementById("comment-modal")
        this.commentsModalExists = this.commentsModal instanceof HTMLElement
        if (this.commentsModalExists) {
            document.body.append(this.commentsModal)
        }

        this.commentsElement = document.getElementById("comments")
        this.noCommentsTextElement = document.getElementById("no-comments-text")

        if (!(this.commentsElement instanceof HTMLElement)) {
            return
        }

        if (this.noCommentsTextElement instanceof HTMLElement) {
            this.noCommentsTextElement.style.display = "none"
        }

        if (typeof userData === "undefined" || !userData.userId) {
            throw new Error(
                "Wir können deinen Benutzerstatus nicht ermitteln. Versuche bitte die Seite neuzuladen oder dich neu anzumelden.",
            )
        }

        this.commentsElement.inputAvatarSrc = userData.userAvatars["48x48"]

        this.addEventListeners()

        window.addEventListener("scroll", (scrollEvent) => {
            scrollEvent.preventDefault()
        })

        // only inside post stream, NOT single view
        if (!postId && this.commentsModalExists && LadiesMain.checkHashtagInUrl("comment-modal")) {
            window.onload = () => this.reopenCommentModal(postId, commentId)
        }

        if (!this.commentsModalExists) {
            this.loadCommentsStarsSingleView(window.location.pathname.split("/").pop())
        }
    }

    async addEventListeners() {
        /** void */
        const self = this

        if (this.openCommentButtons && this.commentsModalExists) {
            for (const btn of this.openCommentButtons) {
                if (btn instanceof HTMLElement) {
                    btn.addEventListener("click", (clickEvent) => this.openPopupFromClickEvent(clickEvent))
                }
            }
        }

        this.commentsModal?.addEventListener("update:modelValue", (e) => {
            self.commentsModal.modelValue = e.detail[0]

            if (!self.commentsModal.modelValue) {
                LadiesMain.removeHashtagFromUrl("postId")
                LadiesMain.removeHashtagFromUrl("comment-modal")
            }

            self.removeDocumentOverflow()
        })

        const commentsElement = document.getElementById("comments")

        commentsElement.addEventListener("sendComment", async function (e) {
            commentsElement.sendCommentButtonLoading = true

            let requestJson

            try {
                if (e.detail[0].replyToComment !== null) {
                    requestJson = await self.sendReplyToComment(e.detail[0].message, e.detail[0].replyToComment.id)
                    const commentId = JSON.parse(requestJson.response).commentId
                    self.insertFakeReply(e.detail[0].message, e.detail[0].replyToComment, commentId)
                } else {
                    requestJson = await self.sendCommentToPost(e.detail[0].message, self.postId)
                    const commentId = JSON.parse(requestJson.response).commentId
                    self.insertFakeComment(e.detail[0].message, commentId)
                }

                if (this.noCommentsTextElement instanceof HTMLElement) {
                    this.noCommentsTextElement.style.display = "none"
                }

                self.incrementFakeCommentCount(self.postId)

                window.setTimeout(() => {
                    InfoPanel.displayMessage("Kommentar erstellt", InfoPanel.Type.Star)
                }, 10)
            } catch {
                window.setTimeout(() => {
                    InfoPanel.displayMessage("Fehler beim Erstellen des Kommentars", InfoPanel.Type.Error)
                }, 10)
            }

            commentsElement.sendCommentButtonLoading = false
            commentsElement._instance.exposed.resetInput()
        })
        commentsElement.addEventListener("deleteComment", async (e) => {
            commentsElement.deleteCommentButtonLoading = true

            await self.deleteComment(e)

            self.decrementFakeCommentCount(self.postId)

            commentsElement.deleteCommentButtonLoading = false
            commentsElement._instance.exposed.closeDeleteCommentPopup()
        })
        commentsElement.addEventListener("reportComment", async (e) => {
            commentsElement.reportCommentButtonLoading = true

            await self.reportComment(e)

            commentsElement.reportCommentButtonLoading = false
            commentsElement.isDeleteCommentPopupOpen = false
            commentsElement._instance.exposed.closeReportCommentPopup()
        })
    }

    async openPopupFromClickEvent(clickEvent /** MouseEvent */) {
        await this.openPopup(clickEvent.currentTarget.dataset.postId, clickEvent.currentTarget.dataset.commentId)
    }

    async openPopup(/** string */ postId, /** string */ commentId) {
        this.updateUrlParameterForCurrentSelectedPost(postId, commentId)

        if (!(this.commentsElement instanceof HTMLElement)) {
            return
        }

        if (this.noCommentsTextElement instanceof HTMLElement) {
            this.noCommentsTextElement.style.display = "none"
        }

        document.body.style.overflow = "hidden"
        document.documentElement.style.overflow = "hidden"

        this.commentsElement.comments = []

        this.postId = postId

        this.comments = {}

        if (this.postId in this.comments) {
            this.commentsElement.comments = this.comments[this.postId]
            this.commentsElement.isContentLoading = false
            this.commentsModal.modelValue = true
            if (this.noCommentsTextElement instanceof HTMLElement) {
                this.noCommentsTextElement.style.display = "none"
            }
        } else {
            this.commentsModal.modelValue = true
            this.commentsElement.isContentLoading = true

            const comments = await this.fetchComments(this.postId, this.starId)
            if (comments === null) {
                this.commentsElement.isContentLoading = false
                this.commentsModal.modelValue = false
                return
            }

            if (comments.length !== 0) {
                this.comments[this.postId] = comments.comments
                this.commentsElement.comments = this.comments[this.postId]
                if (this.noCommentsTextElement instanceof HTMLElement) {
                    this.noCommentsTextElement.style.display = "none"
                }
            } else {
                if (this.noCommentsTextElement instanceof HTMLElement) {
                    this.noCommentsTextElement.style.display = "block"
                }
            }

            this.commentsElement.isContentLoading = false
        }
    }

    async loadCommentsStarsSingleView(/** string */ postId) {
        if (!(this.commentsElement instanceof HTMLElement)) {
            return
        }

        this.commentsElement.comments = []

        this.postId = postId

        this.comments = {}

        if (this.postId in this.comments) {
            this.commentsElement.comments = this.comments[this.postId]
            this.commentsElement.isContentLoading = false
            if (this.noCommentsTextElement instanceof HTMLElement) {
                this.noCommentsTextElement.style.display = "none"
            }
        } else {
            this.commentsElement.isContentLoading = true

            const comments = await this.fetchComments(this.postId, this.creatorId)
            if (comments === null) {
                this.commentsElement.isContentLoading = false
                return
            }

            if (comments.length !== 0) {
                this.comments[this.postId] = comments.comments
                this.commentsElement.comments = this.comments[this.postId]
                if (this.noCommentsTextElement instanceof HTMLElement) {
                    this.noCommentsTextElement.style.display = "none"
                }
            } else {
                if (this.noCommentsTextElement instanceof HTMLElement) {
                    this.noCommentsTextElement.style.display = "block"
                }
            }

            this.commentsElement.isContentLoading = false
        }
    }

    listenForCommentsInteraction(post) {
        const btn = post.querySelectorAll('.post-comments-button[data-target=""]')[0]

        if (btn instanceof HTMLElement) {
            // TODO if comments exists inside single view and user clicks on button maybe scroll/focus comments. Wanted behaviour unknown.
            if (this.commentsModalExists) {
                btn.addEventListener("click", (clickEvent) => this.openPopupFromClickEvent(clickEvent))
            }
        }
    }

    async fetchComments(postId, creatorId) {
        try {
            if (userData.isLoggedIn !== true) {
                return null
            }

            let response

            if (SiteInfo.starsSeparationActive) {
                response = await fetch(`${SiteInfo.starsApiUrl}/api/content/comment?postId=${postId}`, {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${userData.accessToken}`,
                        "Content-Type": "application/json",
                    },
                })
            } else {
                const body = new FormData()
                body.append("postId", postId)
                body.append("userId", userData.userId)
                body.append("creatorId", creatorId)
                response = await fetch(`${this.apiBaseUrl}/v1/StarsComment/GetComments`, {
                    method: "POST",
                    body: body,
                    credentials: "include",
                    mode: "cors",
                })
            }

            if ([200, 404].indexOf(response.status) < 0) {
                if (response.status === 401) {
                    SiteInfo.isLoggedIn = false

                    const notLoggedInModal = openGenericModal(
                        "Du bist nicht mehr angemeldet. Versuche bitte dich neu anzumelden.",
                        "Sitzung abgelaufen",
                    )
                    notLoggedInModal.querySelector("#generic-dialog-close-button").addEventListener("click", () => {
                        $(document).scrollTop(0)
                        window.location.reload()
                    })

                    return null
                }

                openGenericModal(
                    "Kommentare konnten nicht geladen werden.\n" +
                        " Versuche bitte die Seite neuzuladen oder dich neu anzumelden.",
                    "Fehler",
                )
                this.addDocumentOverflow()

                return null
            }

            return await response.json()
        } catch (e) {
            return []
        }
    }

    removeDocumentOverflow() {
        document.body.style.overflow = null
        document.documentElement.style.overflow = null
    }

    addDocumentOverflow() {
        document.body.style.removeProperty("overflow")
        document.documentElement.style.removeProperty("overflow")
    }

    async sendCommentToPost(comment, postId) {
        if (SiteInfo.starsSeparationActive) {
            const response = await fetch(`${SiteInfo.starsApiUrl}/api/commands/create-comment`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${userData.accessToken}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    postId: postId,
                    content: comment,
                }),
            })

            const json = await response.json()

            const commentId = json.commentId

            return {
                response: JSON.stringify({ commentId }),
            }
        }

        const body = new FormData()
        body.append("postId", postId)
        body.append("content", encodeURI(comment))

        const response = await fetch(`${this.apiBaseUrl}/v1/StarsComment/WriteComment`, {
            method: "POST",
            body: body,
            credentials: "include",
        })

        return await response.json()
    }

    async sendReplyToComment(comment, commentId) {
        const replyBody = {
            content: comment,
            replyingTo: commentId,
        }
        if (SiteInfo.starsSeparationActive) {
            const response = await fetch(`${SiteInfo.starsApiUrl}/api/commands/reply-to-comment`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${userData.accessToken}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(replyBody),
            })

            const json = await response.json()

            const commentId = json.commentId

            return {
                response: JSON.stringify({ commentId }),
            }
        }

        const body = new FormData()
        body.append("content", encodeURI(comment))
        body.append("replyingTo", commentId)

        const response = await fetch(`${this.apiBaseUrl}/v1/StarsComment/WriteReplyToComment`, {
            method: "POST",
            body: body,
            credentials: "include",
        })

        return await response.json()
    }

    async deleteComment(data) {
        const { comment, reasons, message } = data.detail[0]

        try {
            if (comment.commenter.isYou) {
                await this.deleteSelfComment(comment.id)
            } else {
                await this.deleteFanComment(comment.id, reasons, message)
            }

            this.commentsElement.comments = this.commentsElement.comments
                .map((c) => {
                    if (c.replies) {
                        c.replies = c.replies.filter((reply) => reply.id !== comment.id)
                    }
                    return c
                })
                .filter((c) => c.id !== comment.id)

            if (this.commentsElement.comments.length === 0) {
                this.noCommentsTextElement.style.display = "block"
            }

            window.setTimeout(() => {
                InfoPanel.displayMessage("Kommentar gelöscht", InfoPanel.Type.Star)
            }, 10)
        } catch (e) {
            window.setTimeout(() => {
                InfoPanel.displayMessage("Fehler beim Löschen des Kommentars", InfoPanel.Type.Error)
            }, 10)
        }
    }

    async reportComment(data) {
        const { comment, message } = data.detail[0]

        try {
            await this.requestReportComment(comment.id, message)

            window.setTimeout(() => {
                InfoPanel.displayMessage("Kommentar gemeldet", InfoPanel.Type.Star)
            }, 10)
        } catch (e) {
            window.setTimeout(() => {
                InfoPanel.displayMessage("Fehler beim Melden des Kommentars", InfoPanel.Type.Error)
            }, 10)
        }
    }

    insertFakeComment(message, commentId) {
        if (typeof userData === "undefined" || !userData.userId) {
            throw new Error(
                "Wir können deinen Benutzerstatus nicht ermitteln. Versuche bitte die Seite neuzuladen oder dich neu anzumelden.",
            )
        }

        this.commentsElement.comments = [
            {
                id: commentId,
                replyingTo: null,
                commenter: {
                    name: userData.userName,
                    avatar: userData.userAvatars["48x48"],
                    isYou: true,
                    isRootContentOwner: userData.userId === this.postOwnerId,
                },
                comment: message,
                createdAt: new Date().toISOString(),
                replies: [],
            },

            ...(this.commentsElement.comments || []),
        ]

        this.commentsElement._instance.exposed.scrollToComment(commentId)
    }

    insertFakeReply(message, replyToComment, fakeCommentId) {
        let commentId = replyToComment.id
        // if replying to is not root comment, get parent id
        if (replyToComment.replyingTo) {
            commentId = this.getParentComment(commentId)?.id
        }
        if (!commentId) {
            console.error("commentId not found", "replyToComment", replyToComment, "fakeCommentId", fakeCommentId)
            return
        }
        this.commentsElement.comments = (this.commentsElement.comments || []).map((comment) => {
            if (comment.id === commentId) {
                if (!comment.replies) {
                    comment.replies = []
                }
                comment.replies.push({
                    id: fakeCommentId,
                    replyingTo: {
                        name: replyToComment.commenter.name,
                        commentId: replyToComment.id,
                    },
                    commenter: {
                        name: userData.userName,
                        avatar: userData.userAvatars["48x48"],
                        isYou: true,
                        isRootContentOwner: userData.userId === this.postOwnerId,
                    },
                    comment: message,
                    createdAt: new Date().toISOString(),
                    replies: [],
                })
            }
            return comment
        })
        this.commentsElement._instance.exposed.scrollToComment(fakeCommentId)
    }

    getParentComment(commentId) {
        return this.commentsElement.comments.find((comment) => comment?.replies?.some((item) => item.id === commentId))
    }

    async deleteSelfComment(id) {
        if (SiteInfo.starsSeparationActive) {
            await fetch(`${SiteInfo.starsApiUrl}/api/commands/delete-comment`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${userData.accessToken}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    commentId: id,
                }),
            })

            return
        }
        const body = new FormData()
        body.append("commentId", id)

        const response = await fetch(`${this.apiBaseUrl}/v1/StarsComment/DeleteComment`, {
            method: "POST",
            body: body,
            credentials: "include",
        })

        return await response.json()
    }

    async deleteFanComment(id, reasons, message) {
        const checkboxReasons = Object.keys(reasons).filter((key) => reasons[key])

        if (SiteInfo.starsSeparationActive) {
            await fetch(`${SiteInfo.starsApiUrl}/api/commands/delete-comment`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${userData.accessToken}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    commentId: id,
                    reasons: checkboxReasons,
                    reasonsExplanation: message,
                }),
            })
            return
        }

        const body = new FormData()
        body.append("commentId", id)
        body.append("reasons", checkboxReasons)
        body.append("reasonsExplanation", message)

        const response = await fetch(`${this.apiBaseUrl}/v1/StarsComment/DeleteComment`, {
            method: "POST",
            body: body,
            credentials: "include",
        })

        return await response.json()
    }

    async requestReportComment(id, message) {
        if (SiteInfo.starsSeparationActive) {
            await fetch(`${SiteInfo.starsApiUrl}/api/commands/report-comment`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${userData.accessToken}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    commentId: id,
                    reason: message,
                }),
            })

            return
        }
        const body = new FormData()
        body.append("message", message)
        body.append("commentId", id)

        const response = await fetch(`${this.apiBaseUrl}/v1/StarsComment/ReportComment`, {
            method: "POST",
            body: body,
            credentials: "include",
        })

        return await response.json()
    }

    incrementFakeCommentCount(postId) {
        const commentCountElement = document.querySelector(`.post-comments-button[data-post-id="${postId}"] > span`)

        if (commentCountElement instanceof HTMLElement) {
            const commentCount = Number.parseInt(commentCountElement.innerText)
            commentCountElement.innerText = commentCount + 1
        }
    }

    decrementFakeCommentCount(postId) {
        const commentCountElement = document.querySelector(`.post-comments-button[data-post-id="${postId}"] > span`)

        if (commentCountElement instanceof HTMLElement) {
            const commentCount = Number.parseInt(commentCountElement.innerText)
            commentCountElement.innerText = commentCount - 1
        }
    }

    async reopenCommentModal(/** string */ postId, /** ?string */ commentId) {
        let post = document.querySelector(`div[id="post-${postId}"]`)

        if (post === null) {
            let postIsVisible = false

            while (!postIsVisible) {
                await this.StarsPost.loadAdditionalPosts()
                post = document.querySelector(`div[id="post-${postId}"]`)

                if (post instanceof HTMLElement) {
                    postIsVisible = true
                }
            }
        }

        if (post instanceof HTMLElement) {
            setTimeout(() => {
                requestAnimationFrame(() => post.scrollIntoView())
            }, 0)

            this.openPopup(postId, commentId).then(() => {
                if (commentId !== null) {
                    this.commentsElement._instance.exposed.scrollToComment(commentId)
                }
            })
        }
    }

    openSubscriptionModal() {
        if (this.subsriptionExpired) {
            const subscriptionModal = document.getElementById("subscriptionModalBuyButtons")
            $(subscriptionModal).modal("show")
        }
    }

    updateUrlParameterForCurrentSelectedPost(/** string */ postId, /** string */ commentId) {
        LadiesMain.addHashtagToUrl("comment-modal")
        LadiesMain.addHashtagToUrl("postId", postId)
        LadiesMain.removeHashtagFromUrl("commentId")
    }
}
